export const TARGET_HEIGHT = 200;
export const MAX_HEIGHT = 300;
export const MAX_ROW_ITEMS = 16;
export const ROW_CONSTRAINTS = {
  maxPhotos: MAX_ROW_ITEMS,
};
